define('customersDetailView',[
  'module',
  'headerFooterView',
  'customersDetailHeaderView',
  'customersDetailBodyView',
  'entities/caccounts'
], function (
  Module,
  HeaderFooterView,
  HeaderView,
  BodyView
) {
  'use strict';

  Module.exports = HeaderFooterView.extend({
    className: 'customers-detail-view ' + HeaderFooterView.prototype.className,
    childHeaderView: HeaderView,
    childView: BodyView  
  });
});

